import Notification from 'notifications/models/Notification'
import { computed, action, makeObservable } from 'mobx'
import { isSameDay } from 'date-fns'

/**
 * Notification Item view model.
 */
export default class NotificationItemViewModel {
  constructor(
    private notification: Notification,
    private getTime: () => Date,
    private onMarkAsRead: (notification: Notification) => unknown
  ) {
    makeObservable(this)
  }

  /**
   * The group type for this notification.
   */
  @computed
  get notificationGroupType(): NotificationGroupType {
    return isSameDay(this.dispatchedAt, this.getTime())
      ? NotificationGroupType.Today
      : NotificationGroupType.Older
  }

  /**
   * Notification ID.
   */
  get id() {
    return this.notification.id || ''
  }

  /**
   * Notification message.
   */
  get text() {
    return this.notification.message
  }

  /**
   * Notification message as plain text.
   */
  get plainText() {
    return this.notification.plainText
  }

  /**
   * Workspace name.
   */
  get workspaceName() {
    return this.notification.recipient.workspace.name
  }

  /**
   * Image source.
   */
  get imageSource() {
    return this.notification.imageUrl
  }

  /**
   * Whether the notification has been read.
   */
  get isRead() {
    return this.notification.status === 'Read'
  }

  /**
   * The action URL, if any.
   */
  get actionUrl() {
    return this.notification.actionUrl
  }

  /**
   * The time at which the notification was dispatched.
   */
  @computed
  get dispatchedAt(): Date {
    return this.notification.dateDispatch
  }

  /**
   * Activates the view model
   */
  activate() {
    //
  }

  /**
   * Deactivates the view model
   */
  deactivate() {
    //
  }

  /**
   * Marks the notification as read.
   */
  @action.bound
  markAsRead() {
    this.onMarkAsRead(this.notification)
  }
}

/**
 * Group type.
 */
export enum NotificationGroupType {
  Today,
  Older,
}
